<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout wrap mt-4>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field
          label="First Name*"
          outlined
          dense
          v-model="associate.firstName"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field
          label="Last Name*"
          dense
          outlined
          v-model="associate.lastName"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Email*" dense outlined v-model="associate.email">
        </v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field
          label="Phone Number*"
          outlined
          dense
          v-model="associate.phoneNumber"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-select
          v-model="associate.roles[0]"
          item-value="_id"
          item-text="name"
          :items="roles"
          label="Select Role"
          outlined
          dense
        />
      </v-flex>
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn
          :disabled="!validAssociate"
          @click="$emit('invite', associate)"
          color="primary"
          >Inite</v-btn
        >
      </v-layout>
    </div>
  </action-modal></template
>
<script>
import ActionModal from "./ActionModal";
import isValidEmail from "@/modules/isValidEmail";
import request from "@/modules/request";

export default {
  name: "InviteAssociateModal",
  data() {
    return {
      associate: {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        canViewPrices: false,
        roles: [],
      },
      roles: [],
    };
  },
  async mounted() {
    await this.loadData();
  },
  props: {
    isOpen: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
  components: { ActionModal },
  computed: {
    validAssociate() {
      const { firstName, lastName, email, phoneNumber, roles } = this.associate;
      return (
        firstName &&
        lastName &&
        email &&
        phoneNumber &&
        isValidEmail(email) &&
        roles.length
      );
    },
    open() {
      return this.isOpen;
    },
  },
  methods: {
    async loadData() {
      const { getRoles } = this;
      const results = await Promise.all([getRoles("associate")])
        .then((results) => {
          return results;
        })
        .catch((error) => {
          console.error(error);
        });

      const [roles] = results;
      Object.assign(this, {
        roles,
      });
      this.loading = false;
    },
    async getRoles(roleType) {
      return request
        .callInternal({
          method: "get",
          route: `/api/admin/roles?roleType=${roleType}`,
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    close() {
      this.$emit("update:inviteAssociateModal", false);
    },
  },
};
</script>
